import React from "react";

const DashboardTable = (props) => {
  return (
    <div style={{height: "30vh", overflowY: "scroll"}}>
      <table class="table">
        <thead class="table-dark">
          <tr>
            <th scope="col">Rank</th>
            <th scope="col">First Name</th>
            <th scope="col">Last Name</th>
            <th scope="col">Score</th>
          </tr>
        </thead>
        <tbody>
          {props.tableData.map((e) => {
            return (
              <tr>
                <th scope="row">{e.rank}</th>
                <td>{e.firstName}</td>
                <td>{e.lastName}</td>
                <td>{e.score}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DashboardTable;
